import React from "react";
import { Pie } from "react-chartjs-2";
import { Chart as ChartJS } from "chart.js/auto";

function PieChart({ chartData,newData }) {
  return <Pie data={newData} />;
}

export default PieChart;
